module.exports = __webpack_public_path__ + "static/media/home-hero-1.13a3c298.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home-hero-1.jpg
// module id = 131
// module chunks = 0